angular.module('tgaApp').constant('security', {
  r: 'ds6fgdtfwqd8wvgcq8ewvbcqw8ef8q8vdfv8yq8asb9w8dq2', // secret hash key
});
